/**
 * Tip of the Day — static tip catalog.
 *
 * Each tip: { id, title, body }. Portuguese, short and actionable.
 * v1 is informational only (no per-tip CTA). To add tips, append here —
 * the rotation index in localStorage wraps automatically.
 */
export const TIPS = [
  {
    id: "spotlight",
    title: "Busca rápida",
    body: "Comece a digitar em qualquer lugar para abrir o Spotlight e trocar de ativo, periodicidade ou tipo de gráfico.",
  },
  {
    id: "group-linking",
    title: "Vincule painéis",
    body: "Clique no ícone de link na aba do gráfico e escolha uma cor para sincronizar gráficos e watchlists pelo mesmo grupo.",
  },
  {
    id: "chained-indicators",
    title: "Indicadores encadeados",
    body: "Aplique um indicador sobre outro — RSI sobre uma média móvel, por exemplo — para revelar padrões pouco óbvios.",
  },
  {
    id: "dom-book",
    title: "DoM e Book de Ofertas",
    body: "Adicione o painel DoM ou Book pelo menu lateral para ver a profundidade de mercado e negociar direto na escada de preços.",
  },
  {
    id: "measure",
    title: "Ferramenta de medição",
    body: "Use a régua na barra de ferramentas para medir variação de preço, percentual e número de barras entre dois pontos.",
  },
  {
    id: "ichimoku-future",
    title: "Nuvem futura do Ichimoku",
    body: "Com o indicador Ichimoku Clouds ativo, a nuvem é projetada 26 períodos à frente do último candle.",
  },
  {
    id: "dock",
    title: "Organize seu workspace",
    body: "Arraste as abas dos painéis para dividir a tela ou empilhá-las. O layout é salvo automaticamente.",
  },
  {
    id: "compare",
    title: "Comparar ativos",
    body: "No painel de Estudos, escolha a categoria Comparar para sobrepor vários ativos em escala percentual.",
  },
  {
    id: "oto",
    title: "Ordens OTO",
    body: "Envie ordens com alvo e stop de uma vez — arraste as linhas de Ganho e Perda no gráfico ou na escada do Book.",
  },
  {
    id: "desktops",
    title: "Múltiplos desktops",
    body: "Salve diferentes layouts como desktops — um para day trade, outro para swing — e alterne pelo menu Desktop.",
  },
  {
    id: "continuous-insertion",
    title: "Inserção contínua",
    body: "Ative a inserção contínua nas configurações para manter a ferramenta de desenho ativa após posicionar um objeto.",
  },
  {
    id: "floating-toolbar",
    title: "Barra flutuante",
    body: "Passe o mouse sobre qualquer painel para revelar a barra de ferramentas flutuante com as ações daquele painel.",
  },
  {
    id: "my-desktops",
    title: "Meus Desktops",
    body: "Use a barra Meus Desktops no topo para trocar de desktop com um clique — favorite os mais usados com a estrela. Nenhuma mudança se perde ao trocar.",
  },
  {
    id: "info-panel",
    title: "Painel Info",
    body: "Abra o painel Info e passe o mouse sobre um gráfico para ver os dados da barra sob o cursor e os valores de todos os indicadores daquele gráfico.",
  },
  {
    id: "silverlight-import",
    title: "Importe do Silverlight",
    body: "Em Carregar Desktop, aba Silverlight, importe seus layouts do gráfico antigo — gráficos, indicadores e desenhos são convertidos automaticamente.",
  },
  {
    id: "point-figure",
    title: "Ponto & Figura",
    body: "No seletor de tipo de gráfico, experimente Ponto & Figura (X e O) — com caixa e reversão configuráveis ou caixa automática pela tabela tradicional.",
  },
  {
    id: "renko",
    title: "Gráfico Renko",
    body: "No seletor de tipo de gráfico, escolha Renko para filtrar o ruído: cada tijolo é um movimento fixo de preço, independente do tempo.",
  },
  {
    id: "one-line-notifications",
    title: "Avisos em uma linha",
    body: "Em Configurações → Negociação, ative as notificações em uma linha: os avisos de ordem ficam compactos e cobrem bem menos o Super DOM.",
  },
  {
    id: "chart-context-menu",
    title: "Menu do gráfico",
    body: "Clique com o botão direito no gráfico para abrir indicadores, desenhos e configurações rápidas, adaptados ao seu dispositivo.",
  },
  {
    id: "navbar-chart-controls",
    title: "Mais espaço na tela",
    body: 'Em Configurações → Gráfico, desligue "Barra de navegação com opções do gráfico" para esconder os controles da navbar e usar só o menu do botão direito.',
  },
];

export default TIPS;
